import React, { useEffect, useRef, useState } from "react";
import { Fade, Zoom } from "react-awesome-reveal";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
// import { BookingForm } from "../components/BookingForm";
// import { BookingFormGroup } from "../components/cruiseBooking/BookingFormGroup";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import "swiper/swiper-bundle.min.css";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { format } from "date-fns";
import { BookingForm } from "../components/BookingForm";
import { Button, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// import { fetchHomePageData } from "../data/homePageSlice";
import { map } from "jquery";
import Counter from "../components/Counter";
import HomeLayout from "../components/HomeLayout";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(min-width:768px) and (max-width:1023px)");
  const isDesktop = useMediaQuery("(min-width:1024px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { homePageData, loading, error } = useSelector(
  //   (state) => state.homePageData
  // );
  // useEffect(() => {
  //   dispatch(fetchHomePageData());
  // }, [dispatch]);

  const locations = [
    { name: "London", description: "Greater London, United Kingdom" },
    { name: "New York", description: "New York State, United States" },
    { name: "Paris", description: "France" },
    { name: "Madrid", description: "Spain" },
    { name: "Santorini", description: "Greece" },
    { name: "Egypt", description: "Cairo, Egypt" },
  ];
  const [isActiveDestination, setIsActiveDestination] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const searchMenuRef = useRef(null);
  const configuration = useSelector(
    (state) => state.configuration.configuration
  );
  // Toggle the active state on click
  const handleDestinationClick = () => {
    setIsActiveDestination(!isActiveDestination);
  };

  // Handle blur event
  const handleBlur = (event) => {
    if (
      searchMenuRef.current &&
      !searchMenuRef.current.contains(event.relatedTarget)
    ) {
      setIsActiveDestination(false);
    }
  };

  // Handle selection of a location
  const handleLocationSelect = (location) => {
    setSelectedLocation(location.name); // Set the selected location
    setSearchTerm(""); // Clear the search term
    setIsActiveDestination(false); // Close the dropdown after selection
  };

  // Filter locations based on search term
  // const filteredLocations = locations.filter((location) =>
  //   location.name.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  const [value, setValue] = useState([null, null]);

  const handleChange = (dates) => {
    setValue(dates);
  };

  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(1);
  const [rooms, setRooms] = useState(1);

  const handleIncrement = (setter) => {
    setter((prev) => prev + 1);
  };

  const handleDecrement = (setter) => {
    setter((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const [isActiveGuest, setIsActiveGuest] = useState(false);

  const GuestMenuRef = useRef(null);

  // Toggle the active state on click
  const handleGuestClick = () => {
    setIsActiveGuest(!isActiveGuest);
  };
  const handleGuestBlur = (event) => {
    if (
      GuestMenuRef.current &&
      !GuestMenuRef.current.contains(event.relatedTarget)
    ) {
      setIsActiveGuest(false);
    }
  };
  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "EEE d MMM"); // e.g., "Wed 2 Mar"
  };
  const disablePastDates = (date) => {
    const today = new Date();
    return date < today.setHours(0, 0, 0, 0); // Disable past dates
  };
  const destinations = [
    {
      city: "Luxor",
      imgSrc: "TITSolutions/img/new/karnak-temple.jpg",
      attractions: "Valley of the Kings, Karnak Temple",
    },
    {
      city: "Aswan",
      imgSrc: "TITSolutions/img/new/philae-temple.jpg",
      attractions: "Philae Temple, High Dam",
    },
    {
      city: "Edfu",
      imgSrc: "TITSolutions/img/new/Temple-of-Horus.jpg",
      attractions: "Temple of Horus",
    },
    {
      city: "Kom Ombo",
      imgSrc: "TITSolutions/img/new/komombo.jpg",
      attractions: "Kom Ombo Temple",
    },
    {
      city: "Cairo",
      imgSrc: "TITSolutions/img/new/cairo.jpg",
      attractions: "Pyramids of Giza, Egyptian Museum",
    },
    {
      city: "Abu Simbel",
      imgSrc: "TITSolutions/img/new/abusimbel.jpg",
      attractions: "Abu Simbel Temples",
    },
  ];
  return (
    <>
      {" "}
      <Helmet>
        <title>{`Home`}</title>
        {/* <title>{`${configuration?.companyName}  Cruises`}</title> */}
        <style>{`
        body{
         overflow:hidden
        }
        @media screen and (min-width: 767px) and (max-width:1100px) {
        body{
         overflow-y: auto;
        }
        }
        `}</style>
      </Helmet>
      <HomeLayout />
      {/*banner */}
      <section className="masthead -type-1 z-5  pb-200">
        <div className="masthead__bg is-in-view">
          <img
            src={
              configuration?.companyBanner
                ? configuration?.companyBanner !==
                  "https://cdn.nilecabins.info/images/uploads/"
                  ? configuration?.companyBanner
                  : "new-bg.jpeg"
                : "new-bg.jpeg"
            }
            alt={configuration?.companyName + " " + "banner"}
            className="js-lazy loaded"
          />
        </div>
        <div className="container">
          <div className="row justify-center">
            <div className="col-auto">
              <div className="text-center water-text">
                <Fade
                  direction="down"
                  duration={1000}
                  delay={0}
                  damping={0.1}
                  cascade
                >
                  <h1 className="text-60 lg:text-40 md:text-30 text-white is-in-view  ">
                    {" "}
                    {t("common.discoverAdventure")}
                  </h1>
                  {/* booking engine  */}
                  {!isMobile && !isTablet && <BookingForm />}
                  {/* <p className="text-white mt-60  is-in-view">
                    Explore breathtaking destinations with exclusive
                    nilecabins.com deals!
                  </p>{" "} */}
                </Fade>
              </div>
            </div>
          </div>
        </div>{" "}
        {isMobile || isTablet ? <BookingForm /> : null}
      </section>
      {/* <section class="layout-pt-lg">
        <div class="container">
          <div class="row justify-content-between  align-items-center">
            <div class="col-lg-7">
              <h2 class="text-30 fw-600">About Nile Cabins </h2>
              <p class="mt-5">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.{" "}
              </p>

              <p class="text-dark-1 mt-30 lg:mt-30 md:mt-20">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ad,
                itaque ipsum corporis libero obcaecati voluptates ea, ratione
                temporibus eius corrupti dolorem atque unde voluptatibus illo
                autem cumque tempora esse!
              </p>
              <p class="text-dark-1 ">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ad,
                itaque ipsum corporis libero obcaecati voluptates ea, ratione
                temporibus eius corrupti dolorem atque unde voluptatibus illo
                autem cumque tempora esse!
              </p>
              <p class="text-dark-1 ">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit ad,
                itaque ipsum corporis libero obcaecati voluptates ea, ratione
                temporibus eius corrupti dolorem atque unde voluptatibus illo
                autem cumque tempora esse!
              </p>
            </div>

            <div class="col-lg-4">
              <img
                loading="lazy"
                width="100%"
                height="500px"
                src="TITSolutions/img/pages/about/2.png"
                alt="about nile cabins"
                class="rounded-4"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="layout-pt-lg layout-pb-lg">
        <div className="container">
          <div className="row justify-center text-center">
            <div className="col-lg-6">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">Special Offers</h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">
                  Embark on an unforgettable journey along the majestic Nile
                  River with our exclusive cruise offers. Explore ancient
                  landmarks, enjoy luxurious accommodations, and create memories
                  that will last a lifetime.
                </p>
              </div>
            </div>
          </div>

          <div className="row y-gap-30 pt-40">
            <div className="col-lg-6">
              <Link to="#." className="row y-gap-20 items-center">
                <div className="col-auto">
                  <img
                    className="size-250 rounded-4"
                    src="TITSolutions/img/new/1.jpeg"
                    alt="Luxury Nile Cruise"
                  />
                </div>

                <div className="col">
                  <div className="text-15 text-light-1">
                    Until December, 2025
                  </div>
                  <h4 className="text-22 fw-600 text-dark-1 mt-10">
                    Luxury Nile Cruise Experience
                  </h4>
                  <p className="mt-10">
                    Sail in style aboard our luxury Nile cruises, featuring
                    world-class amenities, guided tours, and breathtaking views
                    of Egypt's most iconic landmarks. Book now and save!
                  </p>
                </div>
              </Link>
            </div>

            <div className="col-lg-6">
              <Link to="#." className="row y-gap-20 items-center">
                <div className="col-auto">
                  <img
                    className="size-250 rounded-4"
                    src="TITSolutions/img/new/3.jpeg"
                    alt="Dahabiya Nile Cruise"
                  />
                </div>

                <div className="col">
                  <div className="text-15 text-light-1">Until May, 2025</div>
                  <h4 className="text-22 fw-600 text-dark-1 mt-10">
                    Dahabiya Nile Cruise Adventure
                  </h4>
                  <p className="mt-10">
                    Experience the charm of traditional sailing on a Dahabiya
                    Nile cruise. Enjoy personalized service, tranquil waters,
                    and exclusive access to hidden gems along the Nile.
                    Limited-time offer!
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default Home;
